module.exports = __webpack_public_path__ + "img/logo2.edbec47e.png";